import { useState } from "react";
import { faqList } from "@/mocks/nanny";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="text-primary-600 font-label text-sm tracking-[0.2em] uppercase">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">常见问题</h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              关于版本、观看顺序与适用人群，这里整理了几个被问得最多的问题。
            </p>
          </div>

          <div className="space-y-3">
            {faqList.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={item.q} className="bg-background-50 border border-background-200 rounded-lg">
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-4 md:py-5 cursor-pointer"
                  >
                    <span className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                      {item.q}
                    </span>
                    <i
                      className={`shrink-0 text-xl transition-transform text-primary-600 ${
                        isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                      }`}
                    ></i>
                  </button>
                  {isOpen && (
                    <p className="px-5 md:px-6 pb-5 -mt-1 text-foreground-600 text-sm md:text-base leading-relaxed">
                      {item.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>

          <p className="mt-8 text-center text-foreground-500 text-xs md:text-sm leading-relaxed">
            以上内容为作品信息导览，不构成观看渠道推荐。具体可观看情况请以各正版平台的实际页面为准。
          </p>
        </div>
      </div>
    </section>
  );
}